<template>
  <transition
    enter-active-class="animate__animated animate__fadeInLeft"
    leave-active-class="animate__animated animate__fadeOutRight"
    mode="out-in"
    appear
  >
    <slot />
  </transition>
</template>

<script>
import 'animate.css';

export default {
  name: 'FadeInOut',
};
</script>
